export const IBAN_STATUS = Object.freeze({
  CREATED: 'CREATED',
  PENDING: 'PENDING',
  WAITING_ACTION: 'WAITING_ACTION'
} as const)
